export const getAppInitialized = (state) => state.app.initialized;
export const getSection = (state) => state.app.section;
export const getCurrentCity = (state) => state.app.currentCity;
export const getCurrentSubject = (state) => state.app.currentSubject;
